import {
  getCopyWithContentTableColumn,
  getNameDescriptionTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_451'),
      }),
      getNameDescriptionTableColumn({
        field: 'title',
        title: i18n.t('scope.text_439'),
        edit: false,
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.title }</side-page-trigger>
          )
        },
      }),
      {
        field: 'billing_account',
        title: i18n.t('scope.text_406'),
        minWidth: 100,
        slots: {
          default: ({ row }, h) => {
            return [<list-body-cell-wrap copy row={ row } field='billing_account' title={ row.billing_account }>
              <a-button type="link" icon="filter" size="small" slot="appendActions" onClick={ () => this.filterKey(row, 'billing_account') } />
            </list-body-cell-wrap>]
          },
        },
      },
      {
        field: 'subscription',
        title: i18n.t('scope.text_452'),
        minWidth: 100,
        showOverflow: 'ellipsis',
        slots: {
          default: ({ row }, h) => {
            return [<list-body-cell-wrap copy row={ row } field='subscription' title={ row.subscription }>
              <a-button type="link" icon="filter" size="small" slot="appendActions" onClick={ () => this.filterKey(row, 'subscription') } />
            </list-body-cell-wrap>]
          },
        },
      },
      {
        field: 'type',
        title: i18n.t('scope.text_453'),
        minWidth: 70,
        formatter: ({ row, cellValue }) => {
          const options = {
            subscription: i18n.t('scope.text_425'),
            commodity: i18n.t('scope.text_454'),
          }
          return options[cellValue]
        },
      },
      {
        field: 'currency',
        title: i18n.t('scope.text_420'),
        minWidth: 70,
      },
      getTimeTableColumn({ title: i18n.t('scope.text_443'), field: 'since', sortable: true }),
      getTimeTableColumn({ title: i18n.t('scope.text_444'), field: 'until', sortable: true }),
      {
        field: 'count',
        title: i18n.t('scope.text_440'),
        minWidth: 70,
        sortable: true,
        formatter: ({ row }) => {
          return numerify(row.count, '0,0.00')
        },
      },
      {
        field: 'origin_amount',
        title: i18n.t('scope.text_441'),
        minWidth: 70,
        sortable: true,
        formatter: ({ row }) => {
          const sign = row.currency === 'USD' ? '$' : '￥'
          return sign + numerify(row.origin_amount, '0,0.00')
        },
      },
      {
        field: 'amount',
        title: i18n.t('scope.text_298'),
        minWidth: 70,
        sortable: true,
        formatter: ({ row }) => {
          const sign = row.currency === 'USD' ? '$' : '￥'
          return sign + numerify(row.amount, '0,0.00')
        },
      },
      {
        title: i18n.t('scope.text_426'),
        field: 'status',
        minWidth: 70,
        formatter: ({ cellValue }) => {
          const obj = {
            init: i18n.t('scope.text_427'),
            open: i18n.t('scope.text_455'),
            cancelled: i18n.t('scope.text_456'),
            close: i18n.t('scope.text_457'),
            onpay: i18n.t('scope.text_436'),
            due: i18n.t('scope.text_458'),
            paid: i18n.t('scope.text_437'),
            revoke: i18n.t('scope.text_459'),
          }
          return obj[cellValue]
        },
      },
    ]
  },
  methods: {
    filterKey (row, key) {
      const obj = {
        ...this.list.filter,
      }
      if (key === 'billing_account') {
        obj.billing_account_id = [row[key]]
      } else if (key === 'subscription') {
        obj.subscription_id = [row[key]]
      } else {
        obj[key] = [row[key]]
      }
      this.list.changeFilter(obj)
    },
  },
}
